export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_WITHDRAWAL_METHODS_CONFIGURATION':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'RECEIVE_WITHDRAWAL_METHODS_CONFIGURATION':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        config: action.receivedData,
      };
    case 'FAILURE_WITHDRAWAL_METHODS_CONFIGURATION':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
      };
    default:
      return state;
  }
};
